import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue';
import LoginView from '@/views/LoginView.vue';
import DashboardView from '@/views/DashboardView.vue';
import NoteView from '@/views/NoteView.vue';
import EditNoteView from '@/views/EditNoteView.vue';
import ChatView from '@/views/ChatView.vue';
import UploadFileView from '@/views/UploadFileView.vue';
import ResourceView from '@/views/ResourceView.vue'
import EditResourceView from '@/views/EditResourceView.vue'
import SettingsView from '@/views/settings/SettingsView.vue'
import UserListView from '@/views/account/UserListView.vue';
import NewUserView from '@/views/account/NewUserView.vue';
import EditUserView from '@/views/account/EditUserView.vue';
import NewGroupView from '@/views/account/NewGroupView.vue';
import EditGroupView from '@/views/account/EditGroupView.vue';
import AdminErrorView from '@/views/account/AdminErrorView.vue';

import ChatListView from '@/views/ChatListView.vue'
import NewChatView from '@/views/chats/NewChatView.vue'
import ChatScreenView from '@/views/chats/ChatScreenView.vue'
import ChatResourceView from '@/views/chats/ChatResourceView.vue'
import ChatResourceUploadView from '@/views/chats/ChatResourceUploadView.vue'
import ChatEditResourceView from '@/views/chats/ChatEditResourceView.vue'
import ChatSettingView from '@/views/chats/ChatSettingView.vue'
import ChatConnectionView from '@/views/chats/ChatConnectionView.vue'
import ChatAdminErrorView from '@/views/ChatAdminErrorView.vue';
import ChatLayout from '@/components/ChatLayout.vue'

import EditPasswordView from '@/views/settings/EditPasswordView.vue'
import UserPlanView from '@/views/settings/UserPlanView.vue'

import SalesListsView from '@/views/forsales/SalesListsView.vue'
import SalesListsDetailsLayout from '@/views/forsales/SalesListsDetailsLayout.vue'
import SalesListsDetailsView from '@/views/forsales/SalesListsDetailsView.vue'
import NewSalesListsDetailsView from '@/views/forsales/NewSalesListsDetailsView.vue'
import SalesListsImportView from '@/views/forsales/SalesListsImportView.vue'
import SalesUsageDetailsView from '@/views/forsales/SalesMonthCountView.vue'

import OptionsErrorView from '@/views/forsales/OptionsErrorView.vue'
import NewSalesListsView from '@/views/forsales/salesLists/NewSalesListsView.vue'
import EditSalesListsView from '@/views/forsales/salesLists/EditSalesListsView.vue'

import company_db from "@/views/forsales/company_db.vue"

import sales_templates from "@/views/forsales/sales_templates.vue"
import sales_templates_new from "@/views/forsales/sales_templates_new.vue"
import sales_templates_edit from "@/views/forsales/sales_templates_edit.vue"

import fw00_options_error     from "@/views/forwriting/fw00_options_error.vue"
import fw01_signin            from "@/views/forwriting/fw01_signin.vue"
import fw02_login             from "@/views/forwriting/fw02_login.vue"

import fw03_article_lists     from "@/views/forwriting/fw03_ArticleLists.vue"
import fw04_article_lists_new from "@/views/forwriting/fw04_ArticleLists_New.vue"
import fw05_articles_Layout   from "@/views/forwriting/fw05_Articles_Layout.vue"

import fw05_Articles      from "@/views/forwriting/fw05_Articles.vue"
import fw10_ArticlesEdit      from "@/views/forwriting/fw10_Articles_Edit.vue"

import fw11_futured_medias    from "@/views/forwriting/fw11_futured_medias.vue"
import fw14_categories        from "@/views/forwriting/fw14_categories.vue"
import fw17_sample_articles   from "@/views/forwriting/fw17_sample_articles.vue"
import fw20_prompt_templates  from "@/views/forwriting/fw20_prompt_templates.vue"
import fw23_setting           from "@/views/forwriting/fw23_setting.vue"
import fw24_connections       from "@/views/forwriting/fw24_connections.vue"
import fw29_css_selectors     from "@/views/forwriting/fw29_css_selectors.vue"
import fw25_admin             from "@/views/forwriting/fw25_admin.vue"
import fw26_admin_user_new    from "@/views/forwriting/fw26_admin_user_new.vue"
import fw27_admin_user_edit   from "@/views/forwriting/fw27_admin_user_edit.vue"
import fw28_profile           from "@/views/forwriting/fw28_profile.vue"
import fw34_usage             from "@/views/forwriting/fw34_usage.vue"
import fw35_crawl_sites      from "@/views/forwriting/fw35_crawl_sites.vue"
import fw36_crawl_articles   from "@/views/forwriting/fw36_crawl_articles.vue"
import fw37_dashboard        from "@/views/forwriting/fw37_dashboard.vue"
import fw_specific_commercial_transaction from "@/views/forwriting/fw_specific_commercial_transaction.vue"

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { requiresAuth: false },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: SettingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/password',
    name: 'EditPassword',
    component: EditPasswordView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/plan',
    name: 'UserPlan',
    component: UserPlanView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/note/:id',
    name: 'Note',
    component: NoteView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/editnote/:id',
    name: 'EditNote',
    component: EditNoteView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ChatView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/uploadfile',
    name: 'UploadFile',
    component: UploadFileView,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/resource',
    name: 'Resource',
    component: ResourceView,
    meta: { requireAuth: true },
  },
  {
    path: '/resource/:resourceId',
    name: 'EditResource',
    component: EditResourceView,
    meta: { requireAuth: true },
    props: true
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { requireAuth: true },
    children: [
      {
        path: '',
        name: 'UserList',
        component: UserListView
      },
      {
        path: 'user/new',
        name: 'NewUser',
        component: NewUserView
      },
      {
        path: 'user/edit/:userId',
        name: 'EditUser',
        component: EditUserView,
        props: true
      },
      {
        path: 'group/new',
        name: 'NewGroup',
        component: NewGroupView
      },
      {
        path: 'group/edit/:groupId',
        name: 'EditGroup',
        component: EditGroupView,
        props: true
      },
      {
        path: 'admin_error',
        name: 'AdminError',
        component: AdminErrorView,
        props: true
      },
    ]
  },
  {
    path: '/chats',
    name: 'Chats',
    meta: { requireAuth: true },
    children: [
      {
        path: '',
        name: 'ChatList',
        component: ChatListView
      },
      {
        path: 'new',
        name: 'NewChat',
        component: NewChatView
      },
      {
        path: ':chat_id',
        component: ChatLayout,
        children: [
          {
            path: '',
            name: 'ChatScreen',
            component: ChatScreenView
          },
          {
            path: 'resource',
            name: 'ChatResource',
            component: ChatResourceView
          },
          {
            path: 'upload',
            name: 'ChatUpload',
            component: ChatResourceUploadView
          },
          {
            path: 'resource/:resourceId',
            name: 'ChatEditResource',
            component: ChatEditResourceView
          },
          {
            path: 'setting',
            name: 'ChatSetting',
            component: ChatSettingView
          },
          {
            path: 'connection',
            name: 'ChatConnection',
            component: ChatConnectionView
          },

        ]
      }
    ]
  },
  {
    path: '/admin_error',
    name: 'ChatAdminError',
    component: ChatAdminErrorView,
  },

  {
    path: '/forsales',
    name: 'ForSales',
    meta: { requireAuth: true },

    children: [

      {
        path: "company_db",
        children: [
          {
            path: "",
            name: "company_db",
            component: company_db
          },
        ]
      },

      {
        path: "sales_templates",
        children: [
          {
            path: "",
            name: "sales_templates",
            component: sales_templates
          },
          {
            path: "new",
            name: "sales_templates_new",
            component: sales_templates_new
          },
          {
            path: ":sales_template_id",
            name: "sales_templates_edit",
            component: sales_templates_edit
          },
        ]
      },

      {
        path: 'salesLists',
        // name: 'SalesLists',
        // component: SalesListsView,
        children: [
          {
            path: '',     //forsales/salesLists
            name: 'SalesLists',
            component: SalesListsView,
          },
          {
            path: 'new',  //forsales/salesLists/new
            name: 'NewSalesLists',
            component: NewSalesListsView
          },
          {
            path: 'usage',  //forsales/salesLists/usage
            name: 'SalesListsUsage',
            component: SalesUsageDetailsView
          },
          // {
          //   path: ':sales_list_id/setting',
          //   name: 'EditSalesLists',
          //   component: EditSalesListsView
          // },
        ]
      },

      {
        path: "sales_lists",
        name: "sales_lists",
        children: [
          {
            path: ":sales_list_id/sales_lists_details",
            component: SalesListsDetailsLayout,
            children: [
              {
                path: "",
                name: 'SalesListsDetailsView',
                component: SalesListsDetailsView,
              },
              {
                path: 'import',
                name: 'SalesListsImportView',
                component: SalesListsImportView,
              },
              {
                path: 'new',
                name: 'NewSalesListsDetailsView',
                component: NewSalesListsDetailsView,
              },
              {
                path: 'setting',
                name: 'EditSalesListsView',
                component: EditSalesListsView,
              },
            ]
          },
        ]
      },

      {
        path: 'options_error',
        name: 'OptionsError',
        component: OptionsErrorView,
        props: true
      },
    ]
  },

  {
    path: '/forwriting',
    name: 'ForWriting',
    meta: {requireAuth: true},
    redirect: '/forwriting/article_lists',
    children: [
      {
        path: "options_error",
        name: "fw00_options_error",
        component: fw00_options_error,
        props: true
      },

      {
        path: "signin",
        name: "fw01_signin",
        component: fw01_signin,
        meta: { requiresAuth: false },
      },

      {
        path: "login",
        name: "fw02_login",
        component: fw02_login,
        meta: { requiresAuth: false },
      },

      {
        path: "usage",
        name: "fw34_usage",
        component: fw34_usage,
        meta: { requiresAuth: true },
      },

      {
        path: "profile",
        name: "fw28_profile",
        component: fw28_profile,
        meta: { requiresAuth: true },
      },

      {
        path: "admin",
        name: "fw25_admin",
        meta: { requireAuth: true },
        children: [
          {
            path: "",
            name: "fw25_admin_user_list",
            component: fw25_admin
          },
          {
            path: "user/new",
            name: "fw26_admin_user_new",
            component: fw26_admin_user_new
          },
          {
            path: "user/edit/:userId",
            name: "fw27_admin_user_edit",
            component: fw27_admin_user_edit,
            props: true
          },
        ]
      },

      {
        path: "specific-commercial-transaction",
        name: "fw_specific_commercial_transaction",
        component: fw_specific_commercial_transaction,
        meta: { requiresAuth: false },
      },

      {
        path: "privacy-policy",
        name: "fw_privacy_policy",
        component: () => import('../views/forwriting/fw_privacy_policy.vue'),
        meta: { requiresAuth: false },
      },

      {
        path: "service",
        name: "fw_service_intro",
        component: () => import('../views/forwriting/fw_service_intro.vue'),
        meta: { requiresAuth: false },
      },

      {
        path: "article_lists",
        component: fw05_articles_Layout,
        children: [
          {
            path: "",
            name: "article_lists",
            component: fw03_article_lists
          },
          {
            path: "new",
            name: "article_lists_new",
            component: fw04_article_lists_new
          },
          {
            path: ":article_list_id/dashboard",
            name: "fw37_dashboard",
            component: fw37_dashboard
          },
          {
            path: ":article_list_id/articles",
            name: "fw05_articles",
            component: fw05_Articles
          },

          {
            path: ":article_list_id/connections",
            name: "fw24_connections",
            component: fw24_connections
          },

          {
            path: ":article_list_id/articles/:article_id",
            name: "fw10_articles_edit",
            component: fw10_ArticlesEdit
          },

          {
            path: ":article_list_id/futured_medias",
            name: "fw11_futured_medias",
            component: fw11_futured_medias
          },

          {
            path: ":article_list_id/categories",
            name: "fw14_categories",
            component: fw14_categories
          },

          {
            path: ":article_list_id/sample_articles",
            name: "fw17_sample_articles",
            component: fw17_sample_articles
          },

          {
            path: ":article_list_id/prompt_templates",
            name: "fw20_prompt_templates",
            component: fw20_prompt_templates
          },

          {
            path: ":article_list_id/css_selectors",
            name: "fw29_css_selectors",
            component: fw29_css_selectors
          },

          {
            path: ":article_list_id/crawl_sites",
            name: "fw35_crawl_sites",
            component: fw35_crawl_sites
          },

          {
            path: ":article_list_id/crawl_articles",
            name: "fw36_crawl_articles",
            component: fw36_crawl_articles
          },

          {
            path: ":article_list_id/setting",
            name: "fw23_setting",
            component: fw23_setting
          },
        ]
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
